import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 px-4 bg-brand-dark" data-id="element-143">
      <div className="max-w-4xl mx-auto" data-id="element-144">
        <FadeIn data-id="element-145">
          <div className="flex items-center gap-4 mb-8" data-id="element-146">
            <AlertTriangle className="text-brand-orange w-10 h-10 flex-shrink-0" data-id="element-147" />
            <h2 className="text-4xl md:text-5xl font-display font-bold text-white uppercase" data-id="element-148">
              La Ilusión de la{' '}
              <span className="text-brand-orange" data-id="element-149">Seguridad</span>
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-8 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-150">
          <FadeIn delay={0.1} data-id="element-151">
            <p className="border-l-4 border-brand-orange pl-6 py-2 bg-brand-gray/50" data-id="element-152">
              La mayoría de las personas en Estados Unidos viven a un desastre
              de distancia de perderlo todo. No por el desastre en sí, sino por
              lo que olvidan en la huida.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-153">
            <p data-id="element-154">
              Bajo estrés extremo, tu cerebro racional se apaga. He visto a
              familias escapar de incendios con vida, pero pasar los siguientes
              5 años en la miseria porque olvidaron los títulos de propiedad,
              sus registros legales o las medicinas críticas de sus hijos.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-155">
            <p className="font-bold text-white text-2xl mt-8" data-id="element-156">
              Confiar en tu memoria durante una crisis no es un plan,{' '}
              <span className="text-brand-orange underline decoration-2 underline-offset-4" data-id="element-157">
                es una sentencia de caos.
              </span>
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}